<!--
  @author:qun.tao
  @time:2023/2/9
  @disc:在途VIP操作记录
 -->

<template>
  <div class="operation-log" @keyup.enter="enterSearch">
    <el-form class="table-search-bar" inline :model="form" ref="form">
      <el-form-item label="时间" prop="time">
        <el-date-picker
          v-model="form.time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="真实姓名" prop="realName">
        <el-input v-model="form.realName" placeholder="请输入真实姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="userName"
        label="用户名"
        width="100"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="realName"
        label="真实姓名"
        width="100"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="plateNum"
        label="车牌号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="agreementCode"
        label="协议号"
        :show-overflow-tooltip="true">
      </el-table-column>
         <el-table-column
        prop="orderNum"
        label="订单编号"
        :show-overflow-tooltip="true">
      </el-table-column>
         <el-table-column
        prop="takeOrderId"
        label="提货单id"
        :show-overflow-tooltip="true">
      </el-table-column>
      <!--    <el-table-column
        prop="isOnwayVip"
        label="是否在途VIP"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.isOnwayVip===1?'是':'否'}}
        </template>
      </el-table-column> -->
      <el-table-column
        prop="parameter"
        label="方法参数"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="时间"
        width="160"
        :show-overflow-tooltip="true">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'onwayOperation',
  data () {
    return {
      form: {
        time: '',
        realName: ''
      }
    }
  },
  computed: {
    ...mapState({
      list: state => state.onwayOperation.list,
      listState: state => state.onwayOperation.listState
    })
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getOnwayOperationLog']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSearch () {
      const params = {
        ...this.form,
        pageNo: 1
      }
      this.getOnwayOperationLog(params)
    },
    reset () {
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    handleSizeChange (val) {
      this.getOnwayOperationLog({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getOnwayOperationLog({ pageNo: val })
    }
  }
}
</script>
